export default "__VITE_ASSET__891c673f__"